import styled from "styled-components";
import { motion } from "framer-motion";

export const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.surface};
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 16px;
`;

export const TitleBlock = styled.div`
  display: grid;
  gap: 4px;
`;

export const Title = styled.h2`
  font-size: ${({ $fluxo }) => ($fluxo ? "11px" : "12px")};
  font-weight: ${({ $fluxo }) => ($fluxo ? 600 : 700)};
  letter-spacing: ${({ $fluxo }) => ($fluxo ? "0.09em" : "0.08em")};
  text-transform: uppercase;
  color: ${({ theme, $fluxo }) =>
    $fluxo ? theme.textTertiary : theme.textSecondary};
`;

export const Meta = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const buttonCss = `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;
`;

/* No fluxo: botões retangulares arredondados (raio 10, altura 38) como as
   ações do mockup, em vez do pill 999px. */
export const ToggleButton = styled.button`
  ${buttonCss}
  ${({ $fluxo }) => ($fluxo ? "border-radius: 10px; min-height: 38px; font-size: 13px; padding: 0 13px;" : "")}
  border: 1px solid ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  background: ${({ theme, $active }) => ($active ? theme.surfaceAlt : theme.surface)};
  color: ${({ theme, $active }) => ($active ? theme.textPrimary : theme.textSecondary)};

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
    border-color: ${({ theme }) => theme.accent};
  }
`;

export const ResetButton = styled.button`
  ${buttonCss}
  ${({ $fluxo }) => ($fluxo ? "border-radius: 10px; min-height: 38px; font-size: 13px; padding: 0 13px;" : "")}
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
    border-color: ${({ theme }) => theme.accent};
  }
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 16px 14px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 12px;
  font-weight: 600;
`;

export const Body = styled(motion.div)`
  overflow: hidden;
`;

export const CompactPanel = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const CompactDropdown = styled(motion.div)`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 60;
  width: min(760px, calc(100vw - 32px));
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ $fluxo }) => ($fluxo ? "13px" : "12px")};
  /* Fundo SÓLIDO (opaco) — nada de blur/gradiente translúcido aqui, senão
     o conteúdo atrás vaza e prejudica a leitura do formulário de filtro. */
  background: ${({ theme }) => theme.surface};
  ${({ $fluxo }) =>
    $fluxo
      ? "box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 18px 42px rgba(0,0,0,0.45);"
      : "box-shadow: 0 18px 42px rgba(15, 15, 20, 0.16);"}
  overflow: hidden;

  @media (max-width: 640px) {
    position: fixed;
    top: 86px;
    left: 16px;
    right: 16px;
    width: auto;
    max-height: calc(100vh - 110px);
    overflow-y: auto;
  }
`;

export const CompactHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: ${({ $fluxo }) => ($fluxo ? "14px 16px" : "12px 14px")};
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const CompactBody = styled.div`
  padding-top: 12px;
`;
